export const firstPriorityFields = [
  {
    value: "drivers_license",
    label: "Driver's License",
  },
  {
    value: "passport",
    label: "Passport",
  },
  {
    value: "ssn",
    label: "SSN",
  },
];

export const secondPriorityFields = [
  {
    value: "date_of_birth",
    label: "Date of Birth",
  },
  {
    value: "drivers_license",
    label: "Driver's License",
  },
  {
    value: "full_name",
    label: "Full Name",
  },
  {
    value: "first_name",
    label: "First Name",
  },
  {
    value: "last_name",
    label: "Last Name",
  },
  {
    value: "address",
    label: "Address",
  },
  {
    value: "phone",
    label: "Phone",
  },
  {
    value: "passport",
    label: "Passport",
  },
  {
    value: "ssn",
    label: "SSN",
  },
];

export const thirdPriorityFields = [
  // {
  //   value: "address",
  //   label: "Address",
  // },
  {
    value: "date_of_birth",
    label: "Date of Birth",
  },
  {
    value: "full_name",
    label: "Full Name",
  },
  {
    value: "address",
    label: "Address",
  },
  {
    value: "phone",
    label: "Phone",
  },
  {
    value: "email",
    label: "Email",
  },
  {
    value: "debtor_udf",
    label: "Debtor Custom Field",
  },
];
